function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m333.68 351.38c0 42.56-35.58 78.52-77.7 78.52-42.11 0-77.67-35.96-77.68-78.54-88.96.79-178.29 65.85-178.3 160.58l255.97.03 256.03.03c.01-88.22-79.7-159.82-178.32-160.62zm-163.69 97.97-59.24-.01v-30l59.25.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m411.62 247.67c0 16.82-2.11 28.38-6.85 37.49-4.93 9.45-15.23 20.73-36.37 20.72h-.3v-30h.3c6.5 0 13.22 0 13.22-28.21l.01-35.32h-14.05l-.02-88.71c0-4.51-.34-9.01-1.02-13.47h6.74c-18.538-47.932-65.931-80.15-117.25-80.17-51.305 0-98.752 32.236-117.28 80.14h6.66c-.69 4.47-1.03 8.97-1.03 13.49l-.02 88.7-28.71-.01c-8.5 0-15.39-6.89-15.39-15.4l.01-71.39c0-4.86 2.26-9.2 5.78-12.02 17.56-69 78.65-113.5 149.98-113.51 71.33.03 132.41 44.54 149.95 113.54 3.53 2.82 5.79 7.16 5.79 12.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303.695 319.51-.01 31.89c.026 24.076-19.111 45.739-43.1 48.29-27.628 2.708-52.28-20.859-52.28-48.31l.01-31.86c7.5 2.36 16 4.42 26.4 4.44h42.55c10.4-.02 18.91-2.09 26.43-4.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m338.14 124.6c.085-8.621-1.66-17.166-4.98-25.12-42.552 35.453-111.218 35.453-153.77 0-3.32 7.954-5.065 16.499-4.98 25.12l-.02 109.18c0 32.867 27.488 59.878 60.22 60.18h43.33c32.732-.302 60.22-27.313 60.22-60.18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m314.54 75.97c-10.15-7.84-22.87-12.5-36.69-12.49h-43.15c-13.82-.01-26.54 4.65-36.69 12.49 32.298 26.662 84.232 26.663 116.53 0z"
}));

var SvgOperator = function SvgOperator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOperator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/operator.98d59170.svg";
export { ForwardRef as ReactComponent };